<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <ul
        v-if="$config.brand !== 'jkos'"
        class="sidebar-menu"
      >
        <li
          v-if="getRoleType != 50"
          class="active"
        >
          <router-link to="/">
            <i class="fa fa-desktop" />
            <span class="page">
              主頁
            </span>
          </router-link>
        </li>
        <li>
          <a
            class="cursor-pointer"
            @click="goto"
          >
            <i class="fa fa-pie-chart" />
            <span class="page">
              新後台管理系統
            </span>
          </a>
        </li>
        <li>
          <a
            href="https://nidin.shop/resource"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="fa fa-cube" />
            <span class="page">
              你訂資源中心
            </span>
          </a>
        </li>
        <li class="header">
          設定
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/accountTable">
            <i class="fa fa-unlock-alt" />
            <span class="page">
              帳號管理
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/platformTable">
            <i class="fa fa-globe" />
            <span class="page">
              平台管理
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType !== 10">
          <router-link to="/brandTable">
            <i class="fa fa-home" />
            <span class="page">
              品牌管理
            </span>
          </router-link>
        </li>
        <li v-else-if="getRoleType === 10 && sBrandId">
          <router-link :to="'/storeTable/' + sBrandId">
            <i class="fa fa-home" />
            <span class="page">
              店家管理
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/mealTagTable">
            <i class="fa fa-tag" />
            <span class="page">
              餐點種類管理
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/announcement">
            <i class="fa fa-bell" />
            <span class="page">
              訊息公告
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link :to="{ name: 'TradeSetting' }">
            <img class="m-r-5" src="../assets/icon/cash-register.svg" />
            <span class="page">
              金流設定
            </span>
          </router-link>
        </li>
        <li class="header" v-if="getRoleType != 50">
          訂單
        </li>
        <li v-if="getRoleType != 50">
          <router-link to="/orderTable">
            <i class="fa fa-list-alt" />
            <span class="page">
              線上訂單列表
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType != 50">
          <router-link to="/onSiteOrderTable">
            <i class="fa fa-list-alt" />
            <span class="page">
              線下訂單列表
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType != 50">
          <router-link to="/orderExceptionTable">
            <i class="fa fa-exclamation-triangle" />
            <span class="page">
              例外訂單
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99 || getRoleType === 30">
          <router-link to="/blackListTable">
            <i class="fa fa-frown-o" />
            <span class="page">
              黑名單
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/ratingTable">
            <i class="fa fa-star-half-o" />
            <span class="page">
              評價管理
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/menuQuerystringView">
            <i class="fa fa-star-half-o" />
            <span class="page">
              追蹤碼
            </span>
          </router-link>
        </li>
        <li
          v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10"
          class="header"
        >
          會員
        </li>
        <li>
          <router-link to="/memberTable">
            <i class="fa fa-users" />
            <span class="page">
              會員管理
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/shopperMoneyTable">
            <i class="fa fa-money" />
            <span class="page">
              會員消費管理
            </span>
          </router-link>
        </li>
        <li
          v-if="
            getRoleType !== 50
          "
          class="header"
        >
          菜單
        </li>
        <li v-if="!$route.params.brand_id && !sStoreId && getRoleType !== 50">
          <router-link to="/menuDetailTable">
            <i class="fa fa-coffee" />
            <span class="page">
              菜單管理
            </span>
          </router-link>
        </li>
        <li v-if="
          ($route.params.brand_id || sStoreId)
          && getRoleType !== 50
        ">
          <router-link v-if="getRoleType===10" :to="`/brand/${sBrandId}/ajust/menu`">
            <i class="fa fa-plus-square" />
            <span class="page">
              配料庫
            </span>
          </router-link>
          <router-link v-else :to="'/brandMenu/' + brandId">
            <i class="fa fa-plus-square" />
            <span class="page">
              配料庫
            </span>
          </router-link>
        </li>
        <li v-if="
          ($route.params.brand_id || sStoreId)
          && getRoleType !== 50
        ">
          <router-link v-if="getRoleType === 10"
            :to="`/brand/${sBrandId}/build/menu`"
          >
            <i class="fa fa-wrench" />
            <span class="page">
              菜單建置
            </span>
          </router-link>
          <router-link v-else :to="'/brandMenuTable/' + brandId">
            <i class="fa fa-wrench" />
            <span class="page">
              菜單建置
            </span>
          </router-link>
        </li>
        <li v-if="
          ($route.params.brand_id || sStoreId)
          && getRoleType !== 50
        ">
          <router-link :to="'/storeTable/productImage/' + brandIdForStore + (sStoreId && storeList.length === 1 ? '/' + sStoreId : '')">
            <i class="fa fa-picture-o" />
            <span class="page">
              圖片庫
            </span>
          </router-link>
        </li>
        <li v-if="
          ($route.params.brand_id || sStoreId)
          && getRoleType !== 50
        ">
          <router-link :to="'/storeTable/productSetting/' + brandIdForStore + (sStoreId && storeList.length === 1 ? '/' + sStoreId : '')">
            <i class="fa fa-certificate" />
            <span class="page">
              別名 / 描述 / 警語
            </span>
          </router-link>
        </li>
        <li v-if="
          ($route.params.brand_id || sStoreId)
          && getRoleType !== 50
        ">
          <router-link :to="'/cupDiscountTable/' + brandIdForStore + (sStoreId && storeList.length === 1 ? '/' + sStoreId : '')">
            <div class="flex align-center">
              <img
                class="m-r-5"
                style="width: 18px; height: 18px;"
                src="../assets/icon/i_reusable_cup.svg"/>
              <span class="page">
                自備飲料杯管理
              </span>
            </div>
          </router-link>
        </li>
        <li v-if="
          ($route.params.brand_id || sStoreId)
          && getRoleType !== 50
        ">
          <router-link 
            v-if="getRoleType === 10"
            :to="`/brand/${sBrandId}/schedule/menu`"
          >
          <i class="fa fa-clock-o" />
            <span class="page">
              菜單排程
            </span>
          </router-link>
          <router-link v-else :to="'/brandScheduleTable/' + brandId">
            <i class="fa fa-clock-o" />
            <span class="page">
              菜單排程
            </span>
          </router-link>
        </li>
        <li class="header">
          即時控管
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/printerTable">
            <i class="fa fa-print" />
            <span class="page">
              出單機管理
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/disItemTable">
            <i class="fa fa-ban" />
            <span class="page">
              停賣管理
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/disItemScheduleTable">
            <i class="fa fa-ban" />
            <span class="page">
              時段停賣管理
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/limitedItemScheduleTable">
            <i class="fa fa-university" />
            <span class="page">
              門市限時限量
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/mqttTable">
            <i class="fa fa-plug" />
            <span class="page">
              連線管理
            </span>
          </router-link>
        </li>
        <li
          v-if="getRoleType !== 50"
          class="header"
        >
          活動
        </li>
        <li v-if="getRoleType !== 50">
          <router-link to="/discountTable">
            <i class="fa fa-tag" />
            <span class="page">
              現折活動管理
            </span>
          </router-link>
        </li>
        <li
          v-if="getRoleType === 99 || getRoleType === 30"
          class="header"
        >
          對帳
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/cashAccountTable">
            <i class="fa fa-credit-card" />
            <span class="page">
              對帳記錄表
            </span>
          </router-link>
        </li>
        <li >
          <router-link to="/venderTradeTable">
            <i class="fa fa-credit-card" />
            <span class="page">
              廠商對帳記錄表
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/cashAccountErrorTable">
            <i class="fa fa-times-circle" />
            <span class="page">
              對帳錯誤紀錄表
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/cashAccountSearch">
            <i class="fa fa-search" />
            <span class="page">
              查詢交易資訊
            </span>
          </router-link>
        </li>
        <li
          v-if="getRoleType === 99 || getRoleType === 30"
          class="header"
        >
          統計報表
        </li>
        <li v-if="getRoleType === 99 || getRoleType === 30">
          <router-link to="/weekChartDash">
            <i class="fa fa-pie-chart" />
            <span class="page">
              週報表
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99 || getRoleType === 30">
          <router-link to="/chartDash">
            <i class="fa fa-pie-chart" />
            <span class="page">
              月報表
            </span>
          </router-link>
        </li>
        <li v-if="getRoleType === 99">
          <router-link to="/marketingChart">
            <i class="fa fa-pie-chart" />
            <span class="page">
              行銷報表
            </span>
          </router-link>
        </li>
        <li v-if="[99, 30, 10].includes(getRoleType)">
          <router-link to="/operatingChart">
            <i class="fa fa-pie-chart" />
            <span class="page">
              營運報表
            </span>
          </router-link>
        </li>
        <li v-if="[99].includes(getRoleType)">
          <router-link to="/systemUsage">
            <i class="fa fa-pie-chart" />
            <span class="page">
              系統使用率報表
            </span>
          </router-link>
        </li>
      </ul>
      <ul
        v-else
        class="sidebar-menu"
      >
        <li class="header">
          設定
        </li>
        <li v-if="getRoleType !== 10">
          <router-link to="/brandTable">
            <i class="fa fa-home" />
            <span class="page">
              品牌管理
            </span>
          </router-link>
        </li>
        <li v-else-if="getRoleType === 10 && sBrandId">
          <router-link :to="'/storeTable/' + sBrandId">
            <i class="fa fa-home" />
            <span class="page">
              店家管理
            </span>
          </router-link>
        </li>
        <li
          v-if="getRoleType !== 50"
          class="header"
        >
          菜單
        </li>
        <li v-if="!$route.params.brand_id && !sStoreId && getRoleType !== 50">
          <router-link to="/menuDetailTable">
            <i class="fa fa-coffee" />
            <span class="page">
              菜單管理
            </span>
          </router-link>
        </li>
        <li v-if="($route.params.brand_id || sStoreId) && getRoleType !== 50">
          <router-link :to="'/brandMenu/' + brandId">
            <i class="fa fa-plus-square" />
            <span class="page">
              配料庫
            </span>
          </router-link>
        </li>
        <li v-if="($route.params.brand_id || sStoreId) && getRoleType !== 50">
          <router-link :to="'/brandMenuTable/' + brandId">
            <i class="fa fa-wrench" />
            <span class="page">
              菜單建置
            </span>
          </router-link>
        </li>
        <li v-if="($route.params.brand_id || sStoreId) && getRoleType !== 50">
          <router-link :to="'/storeTable/productImage/' + brandIdForStore + (sStoreId && storeList.length === 1 ? '/' + sStoreId : '')">
            <i class="fa fa-picture-o" />
            <span class="page">
              圖片庫
            </span>
          </router-link>
        </li>
        <li v-if="($route.params.brand_id || sStoreId) && getRoleType !== 50">
          <router-link :to="'/storeTable/productSetting/' + brandIdForStore + (sStoreId && storeList.length === 1 ? '/' + sStoreId : '')">
            <i class="fa fa-certificate" />
            <span class="page">
              別名/描述/警語
            </span>
          </router-link>
        </li>
        <li v-if="($route.params.brand_id || sStoreId) && getRoleType !== 50">
          <router-link :to="'/brandScheduleTable/' + brandId">
            <i class="fa fa-clock-o" />
            <span class="page">
              菜單排程
            </span>
          </router-link>
        </li>
        <li class="header">
          即時控管
        </li>
        <li>
          <router-link to="/disItemTable">
            <i class="fa fa-ban" />
            <span class="page">
              停賣管理
            </span>
          </router-link>
        </li>
      </ul>
    </section>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
import { setSharedToken } from '../assets/js/shared-token.js'

export default {
  name: 'Sidebar',
  data () {
    return {
      sBrandId: '',
      sStoreId: '',
      storeList: []
    }
  },
  computed: {
    ...mapGetters([
      'getAccount',
      'getRoleType',
      'getUserId'
    ]),
    allow_update_menu () {
      return this.$store.state.storeInfo.allow_update_menu === 1
    },
    brandId () {
      if (this.getRoleType === 99) return this.$route.params.brand_id
      else if (this.getRoleType === 30) return this.$route.params.brand_id
      else if (this.getRoleType === 10) return this.sStoreId
    },
    brandIdForStore () {
      // 門市圖片庫 & 門市別名描述警語的 BrandId
      if (this.getRoleType === 99) return this.$route.params.brand_id
      else if (this.getRoleType === 30) return this.$route.params.brand_id
      else if (this.getRoleType === 10) return this.sBrandId || this.$route.params.brand_id
    },
    getDataH () {
      return this.$parent.getDataH
    }
  },
  created () {
    if (this.getRoleType !== 99) {
      this.getBrandList()
    }
  },
  methods: {
    getBrandList () {
      console.log('getBrandList | Sidebar') // 重要 console.log 不要移除
      const url = '/brand/list?page=1&size=1'
      this.getDataH('get', url, null, async (response) => {
        if (response.data.status === 200) {
          this.sBrandId = response.data.list[0].id
          this.$store.commit('SET_BRANDS', response.data.list)
          this.$store.commit('SET_BRAND_ID', response.data.list[0]['id'])
          if (this.getRoleType === 10) {
            await this.getStoreBrief(response.data.list[0].id)
            this.getStoreInfo()
          }
        }
      })
    },
    getStoreBrief (brandId) {
      return new Promise((resolve) => {
        console.log('getStoreBrief | Sidebar') // 重要 console.log 不要移除
        const url = '/brand/' + brandId + '/storeListBrief'
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.storeList = response.data.list
            this.sStoreId = response.data.list[0].store_id
            this.$store.commit('SET_STORES', response.data.list)
            this.$store.commit('SET_STORE_ID', response.data.list[0]['store_id'])
            resolve()
          }
        })
      })
    },
    getStoreInfo () {
      console.log('getStoreInfo | Sidebar') // 重要 console.log 不要移除
      const url = '/store/' + this.$store.state.storeId + '/info'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.$store.commit('SET_STORE_INFO', response.data.info)
        }
      })
    },
    goto () {
      setSharedToken(window.localStorage.getItem(this.$config.token))
      window.location.href = this.$config.bdms
    }
  }
}
</script>

<style lang="sass">
  .wrapper.fixed_layout .main-sidebar
    overflow: auto !important
  .sidebar-menu > li > a
    padding: 12px 15px 12px 15px
  .sidebar-menu li.active > a > .fa-angle-left,
  .sidebar-menu li.active > a > .pull-right-container > .fa-angle-left
    animation-name: rotate
    animation-duration: .2s
    animation-fill-mode: forwards
  @keyframes rotate
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(-90deg)
  .icon-table
    top: 3px
    background-image: url("/static/img/icon/icon_table_gray.png")
    width: 18px
    height: 18px
    display: inline-block
    background-size: 18px 18px
  #table-menu:hover, #table-menu:active, #table-menu.active
    .icon-table
      background-image: url("/static/img/icon/icon_table.png")
  .cursor-pointer
    cursor: pointer
</style>



// WEBPACK FOOTER //
// Sidebar.vue?51e187e7